import { render, staticRenderFns } from "./SafetyCheck.vue?vue&type=template&id=0ea4ec88"
import script from "./SafetyCheck.vue?vue&type=script&lang=ts"
export * from "./SafetyCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports